import type { RightDrawerTabType } from './types';
import type { TOwnerScope } from './useOwnerScope';
import type { TStudyRelevance } from './useStudyRelevance';

import { OWNER_SCOPE } from './useOwnerScope';
import { STUDY_RELEVANCE } from './useStudyRelevance';

export const getOwnerScopeFromURL = (
  tabType: RightDrawerTabType,
  searchParams: URLSearchParams
): TOwnerScope => {
  const owner = searchParams.get(`${tabType}Owner`);
  if (owner === OWNER_SCOPE.Personal || owner === OWNER_SCOPE.Clinic) {
    return owner;
  }
  return OWNER_SCOPE.All;
};

export const getStudyRelevanceFromURL = (
  tabType: RightDrawerTabType,
  searchParams: URLSearchParams
): TStudyRelevance => {
  const relevance = searchParams.get(`${tabType}Relevance`);
  if (relevance === STUDY_RELEVANCE.Study || relevance === STUDY_RELEVANCE.Global) {
    return relevance;
  }
  return STUDY_RELEVANCE.All;
};
